import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class InternalService {
  private internatSubject: BehaviorSubject<any> = new BehaviorSubject({});
  internalListener = this.internatSubject.asObservable();
  
  constructor() { }

  internalNotify(value){
    this.internatSubject.next(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/internal.service.ts